import { Helper } from "../../core/util/helper";
import { TextBox } from "../../core/components/textBox"
import { FieldInstance } from "../../core/components/field"
import { ComponentHelper } from "../../core/util/componentHelper";
import EditTranslations, { EditTranslationsProps } from "../../reportMetaData/editTranslations"
import { BaseComponentProps } from "../../core/components/baseComponentProps";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class EditChars extends React.Component<EditCharsProps, EditCharsState>{

    private factory = ComponentHelper.createFactory();
    private key = "en";
    private translations: StringKeyDictionary<string>
    private initialLoad: boolean = true;

    constructor(props: EditCharsProps) {
        super(props)
        const griData = JSON.parse(JSON.stringify(props.value));
        delete griData[this.key];
        this.translations = props.context.translations;
        this.state = {
            gridData: griData,
            textBoxValue: Helper.getValueOrDefault(this.props.value[this.key], ""),
            gridOpen: false
        }
    }

    private afterChange = () => {
        let value = this.state.gridData;
        value[this.key] = this.state.textBoxValue;
        this.props.onChange(this.props.field, value);

    }

    private createTextBox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.textBoxValue;
        props.onChange = (_, value: string) => {
            this.setState({ textBoxValue: value }, this.afterChange)
        }

        return (
            <FieldInstance label={this.props.field.name} noHover={true} labelStyle={{ width: "45%"}}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private createGrid = () => {
        const onChange = (_, value: {}) => {
            this.setState({ gridData: value }, this.afterChange)
        }

        const props: EditTranslationsProps = {
            context: this.props.context as any,
            disabled: this.props.disabled,
            field: this.props.field,
            onChange: onChange,
            value: this.state.gridData,
            entity: this.props.entity,
            ignoredLanguages: [this.key]
        };
        return (
            <div className={this.state.gridOpen ? `unitOfMeasurment__units__chars__grid--open ${!this.initialLoad ? "open__chars__grid" : ""}` : `unitOfMeasurment__units__chars__grid--close ${!this.initialLoad ? "close__chars__grid": ""}`}>
                <EditTranslations {...props} />
            </div>
        );
    }

    private createLabel = () => {
        return (
            <div className="unitOfMeasurment__units__chars__label" onClick={() => { this.setState({ gridOpen: !this.state.gridOpen }) }}>
                <label>
                    {this.state.gridOpen ? this.translations["WebSMS.GeneralSettings.Units.ShowLess"] : this.translations["WebSMS.GeneralSettings.Units.ShowMore"]}
                </label>
            </div>
        );
    }

    componentDidMount() {
        this.initialLoad = false;
    }

    render() {
        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                {this.createTextBox()}
                {this.createGrid()}
                {this.createLabel()}
            </div>
        );
    }
}

interface EditCharsProps extends BaseComponentProps{
    value: {};
    onChange?(field: any, value: {});
    entity: any;
    context: any;
}

interface EditCharsState {
    textBoxValue: string;
    gridData: {};
    gridOpen: boolean;
}